import useThemeStore from '@/store/themeStore';

function SunIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.6" />
      <path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8"
        stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function MoonIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M20 14.5A8 8 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5Z"
        stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * Theme switch. `variant="icon"` renders a compact round button (for the HUD);
 * `variant="full"` renders a labelled row (for settings).
 */
export default function ThemeToggle({ variant = 'icon', className = '' }) {
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);
  const isDark = theme === 'dark';

  if (variant === 'full') {
    return (
      <button
        type="button"
        onClick={toggle}
        className={`flex w-full items-center justify-between rounded-2xl border border-edge bg-surface px-4 py-3 text-fg transition active:scale-[0.99] ${className}`}
      >
        <span className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-surfaceAlt text-accent">
            {isDark ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
          </span>
          <span className="text-left">
            <span className="block font-urban text-sm font-bold">Aparência</span>
            <span className="block text-xs text-muted">{isDark ? 'Modo escuro' : 'Modo claro'}</span>
          </span>
        </span>
        <span
          className="relative h-7 w-12 rounded-full transition-colors"
          style={{ background: isDark ? 'rgb(var(--hc-accent))' : 'rgb(var(--hc-border))' }}
        >
          <span
            className="absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-all"
            style={{ left: isDark ? '22px' : '2px' }}
          />
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Mudar para modo claro' : 'Mudar para modo escuro'}
      className={`flex h-9 w-9 items-center justify-center rounded-full border border-edge bg-surface text-accent transition active:scale-90 ${className}`}
    >
      {isDark ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
    </button>
  );
}
